import { render, staticRenderFns } from "./bitRelational.vue?vue&type=template&id=f1d55ee4&scoped=true"
import script from "./bitRelational.vue?vue&type=script&lang=js"
export * from "./bitRelational.vue?vue&type=script&lang=js"
import style0 from "./bitRelational.vue?vue&type=style&index=0&id=f1d55ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d55ee4",
  null
  
)

export default component.exports